exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/core-js/modules/_object-pie.js
// module id = ../../../../core-js/modules/_object-pie.js
// module chunks = 1